import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationTemplateService {

  constructor(public http: AppHttpClient) { }

  getTemplates(approach?: string) {
    const params = approach ? { approach } : {};
    return this.http.get('notification-templates', params);
  }

  createTemplate(template: any) {
    return this.http.post('notification-templates', template);
  }

  updateTemplate(template: any) {
    return this.http.put('notification-templates', template);
  }

  deleteTemplate(approach: string, eventRole: string) {
    return this.http.delete('notification-templates', { approach, eventRole });
  }
}
